const formatCurrency = (value = 0) => {
  // TODO: Should this be a try catch? If it is not a number or any error should there be feedback / error collection
  value = Number(value) || 0;
  const currencyValue = value.toLocaleString("en-UK", {
    style: "currency",
    currency: "GBP"
  });

  return currencyValue;
};

export default formatCurrency;
